import { render, staticRenderFns } from "./statisticalAnalysis.vue?vue&type=template&id=deef8f84&scoped=true"
import script from "./statisticalAnalysis.vue?vue&type=script&lang=js"
export * from "./statisticalAnalysis.vue?vue&type=script&lang=js"
import style0 from "./statisticalAnalysis.vue?vue&type=style&index=0&id=deef8f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deef8f84",
  null
  
)

export default component.exports